import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { RepIntelCountersRequestDto, RepIntelCountersResponseDto, RepIntelSearchRequestDto, RepIntelSearchResponseDto, RepIntelSignalsResponseDto } from '../../dto';

@Injectable({
  providedIn: 'root'
})
export class RepintelApiService {
  private readonly url: string = 'service/contactcloud/repintel';

  constructor(private readonly baseApiService: BaseApiService) {
  }

  getSignals(): Observable<RepIntelSignalsResponseDto> {
    return this.baseApiService.get(`${this.url}/signals`);
  }

  getCounts(req: RepIntelCountersRequestDto): Observable<RepIntelCountersResponseDto> {
    return this.baseApiService.post(`${this.url}/count`, req);
  }

  getSearch(req: RepIntelSearchRequestDto): Observable<RepIntelSearchResponseDto> {
    return this.baseApiService.post(`${this.url}/search`, req, { showError: true });
  }
}
